import { Box, Typography } from '@mui/material';
import React from 'react';
export const DragElement = (props) => {
    return (React.createElement(Box, { sx: {
            display: 'flex',
            padding: 1,
            border: '1px solid rgba(0, 0, 0, 0.6)',
            borderRadius: 1,
            color: '#000000',
            backgroundColor: 'rgba(255, 255, 255, 0.6)',
        } },
        props.icon && React.createElement(Box, { sx: { display: 'flex' } }, props.icon),
        React.createElement(Typography, { component: 'div', sx: { ml: 1 } }, props.label)));
};
